export type CachedIpLocation = {
  country: string;
  region: string;
  latitude: number | null;
  longitude: number | null;
  timestampMs: number;
};

const STORAGE_KEY = "myhu.ipLocationCache.v1";
const DEFAULT_TTL_MS = 24 * 60 * 60 * 1000; // 24 hours

function safeParseJson(value: string): unknown {
  try {
    return JSON.parse(value);
  } catch {
    return null;
  }
}

export function readCachedIpLocation(
  ttlMs: number = DEFAULT_TTL_MS,
): CachedIpLocation | null {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return null;
    const parsed = safeParseJson(raw) as Partial<CachedIpLocation> | null;
    if (!parsed) return null;

    const timestampMs = Number(parsed.timestampMs);
    if (!Number.isFinite(timestampMs)) return null;
    if (Date.now() - timestampMs > ttlMs) return null;

    const country = typeof parsed.country === "string" ? parsed.country : "";
    const region = typeof parsed.region === "string" ? parsed.region : "";

    const latitude =
      typeof (parsed as any).latitude === "number"
        ? (parsed as any).latitude
        : (parsed as any).latitude != null
          ? Number((parsed as any).latitude)
          : null;
    const longitude =
      typeof (parsed as any).longitude === "number"
        ? (parsed as any).longitude
        : (parsed as any).longitude != null
          ? Number((parsed as any).longitude)
          : null;

    return { country, region, latitude, longitude, timestampMs };
  } catch {
    return null;
  }
}

export function writeCachedIpLocation(
  loc: Omit<CachedIpLocation, "timestampMs">,
) {
  try {
    const payload: CachedIpLocation = { ...loc, timestampMs: Date.now() };
    localStorage.setItem(STORAGE_KEY, JSON.stringify(payload));
  } catch {
    // ignore quota / privacy mode errors
  }
}

export function clearCachedIpLocation() {
  try {
    localStorage.removeItem(STORAGE_KEY);
  } catch {
    // ignore
  }
}

